<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Type of Insurance</h3>
          <!-- <ul class="breadcrumb">
            <li class="breadcrumb-item"><a>Insurance</a></li>
            <li class="breadcrumb-item active">Type of Insurance</li>
          </ul> -->
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>New Type of Insurance
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <form id="saveForm" @submit.prevent="save"></form>
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="action-column">Action</th>
                <th class="description-column">
                  <button class="btn p-0" @click="setSortBy('description')">
                    Type of Insurance
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'description'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'description_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('sequence')">
                    Sequence
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'sequence'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'sequence_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="showAddMode" class="table-info">
                <td class="action-column">
                  <button
                    type="submit"
                    class="btn"
                    title="Save"
                    form="saveForm"
                  >
                    <i class="fa fa-save"></i>
                  </button>
                  <button
                    type="button"
                    class="btn"
                    title="Cancel"
                    @click="cancel"
                  >
                    <i class="fa fa-window-close-o"></i>
                  </button>
                </td>
                <td class="description-column">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.description"
                    maxlength="200"
                    form="saveForm"
                    required
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="formData.sequence"
                    step="1"
                    min="1"
                    max="100"
                    form="saveForm"
                    required
                  />
                </td>
              </tr>
              <tr
                v-for="item in insuranceTypes"
                :key="item.Id"
                :class="!item.IsActive ? 'disabled-color' : ''"
              >
                <template v-if="formData.id !== item.Id">
                  <td class="action-column">
                    <label class="toggler">
                      <input
                        type="checkbox"
                        v-model="item.IsActive"
                        @change="toggle(item, $event)"
                      />
                      <span class="slider round"></span>
                    </label>
                    <button
                      v-if="item.IsActive"
                      class="btn mt-2"
                      title="Edit"
                      @click="edit(item)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      v-if="item.IsActive"
                      class="btn mt-2"
                      title="Delete"
                      @click="remove(item.Id)"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                  <td class="description-column">{{ item.Description }}</td>
                  <td>{{ item.Sequence }}</td>
                </template>
                <template v-else>
                  <td class="action-column table-info">
                    <button
                      type="submit"
                      class="btn"
                      title="Save"
                      form="saveForm"
                    >
                      <i class="fa fa-save"></i>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      title="Cancel"
                      @click="cancel"
                    >
                      <i class="fa fa-window-close-o"></i>
                    </button>
                  </td>
                  <td class="description-column table-info">
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.description"
                      maxlength="200"
                      form="saveForm"
                      required
                    />
                  </td>
                  <td class="table-info">
                    <input
                      type="number"
                      class="form-control"
                      v-model="formData.sequence"
                      step="1"
                      min="1"
                      max="100"
                      form="saveForm"
                      required
                    />
                  </td>
                </template>
              </tr>
              <tr v-if="insuranceTypes && !insuranceTypes.length">
                <td colspan="3" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      insuranceTypes: null,
      showAddMode: false,
      noRecordText: config.NO_RECORD_TEXT,
      formData: {
        id: "",
        description: "",
        sequence: "",
      },
      //for pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getInsuranceTypes() {
      let param = {
        Token: this.token,
        SortBy: this.paging.SortBy,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceType(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.insuranceTypes = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //action
    resetForm() {
      this.formData = {
        id: "",
        description: "",
        sequence: "",
      };
    },
    add() {
      this.showAddMode = true;
      this.resetForm();
    },
    edit(payload) {
      this.showAddMode = false;
      this.resetForm();
      this.formData.id = payload.Id;
      this.formData.description = payload.Description;
      this.formData.sequence = payload.Sequence;
    },
    cancel() {
      this.showAddMode = false;
      this.resetForm();
      this.getInsuranceTypes();
    },
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteInsuranceType(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.formData.id,
        Description: this.formData.description,
        Sequence: this.formData.sequence,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveInsuranceType(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },

    toggle(payload, $event) {
      let isActive = $event.target.checked;
      let param = {
        Token: this.token,
        Id: payload.Id,
        IsActive: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleInsuranceType(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.cancel();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination
    setSortBy(payload) {
      switch (payload) {
        case "description":
          if (this.paging.SortBy === "description") {
            this.paging.SortBy = "description_desc";
          } else if (this.paging.SortBy === "description_desc") {
            this.paging.SortBy = "description";
          } else {
            this.paging.SortBy = "description";
          }
          break;
        case "sequence":
          if (this.paging.SortBy === "sequence") {
            this.paging.SortBy = "sequence_desc";
          } else if (this.paging.SortBy === "sequence_desc") {
            this.paging.SortBy = "sequence";
          } else {
            this.paging.SortBy = "sequence";
          }
          break;
      }
      this.getInsuranceTypes();
    },
  },

  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
    else this.getInsuranceTypes();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Insurance/InsuranceType.vue